/*
* sidebar config
* */

import './sidebar.css'

/* Components */
import '../../micro/res-form/index'